import { Client as SwitcherClient } from "@switcherstudio/switcher-api-client";

export const client = new SwitcherClient(
  {
    showLoading: false,
  },
  process.env.REACT_APP_API_URL ||
    "https://silversunnapi-develop.azurewebsites.net"
);
